// ============================================================================
// HINDI TRANSLATIONS - CHAPTER 2: निर्गमन
// ============================================================================
// स्तर 14-26 (13 स्तर, 39 प्रश्न)

export const chapter2Translations = {
  name: "निर्गमन",
  description: "परमेश्वर के लोगों की मुक्ति... परमेश्वर को जानना हमारे जीवन को बदल देता है",
  
  spiritualWisdom: {
    principle: "परमेश्वर का ज्ञान मुक्त करता है और रूपांतरित करता है",
    scripture: "तुम सत्य को जानोगे, और सत्य तुम्हें स्वतंत्र करेगा (यूहन्ना 8:32)",
    application: "जैसे इस्राएल मिस्र से मुक्त हुआ, परमेश्वर का ज्ञान हमें आध्यात्मिक दासता से मुक्त करता है"
  },
  
  levels: {
    14: {
      name: "मूसा जल से बचाया गया",
      challenge: "स्त्री ने गर्भवती होकर एक पुत्र को जन्म दिया। जब उसने देखा कि वह सुंदर है...",
      easy: {
        question: "मूसा की माँ ने अपने पुत्र को किसमें छिपाया?",
        options: ["एक गुफा", "एक सरकंडे की टोकरी", "एक टोकरी", "एक घर"],
        hint: "यह पात्र नील नदी पर तैरता था",
        funFact: "🏺 सरकंडे की टोकरी को जलरोधी बनाने के लिए राल से लेपित किया गया था!"
      },
      medium: {
        question: "मूसा को सरकंडों के बीच किसने पाया?",
        options: [
          "फिरौन की बेटी",
          "एक मिस्री दासी",
          "उसकी बहन मरियम",
          "एक मिस्री पुजारी"
        ],
        hint: "मिस्री शाही परिवार की एक सदस्य",
        funFact: "👑 विडंबना यह है कि फिरौन का परिवार ही उसे बचाता है जो उसे चुनौती देगा!"
      },
      hard: {
        question: "दैवीय प्रावधान हमारे शत्रुओं का भी उपयोग कैसे करता है?",
        options: [
          "उन्हें परिवर्तित करके",
          "अपने उद्देश्यों को पूरा करने के लिए परिस्थितियों को व्यवस्थित करके",
          "उन्हें दंडित करके",
          "उन्हें अनदेखा करके"
        ],
        hint: "यह घटनाओं में परमेश्वर का हाथ देखने के बारे में है",
        funFact: "✨ मूसा उसी के महल में बड़ा हुआ जो अपने लोगों पर अत्याचार कर रहा था!"
      }
    },
    
    15: {
      name: "जलती हुई झाड़ी",
      challenge: "यहोवा के दूत ने उसे एक झाड़ी में से आग की लौ में दर्शन दिया...",
      easy: {
        question: "मूसा को जलती हुई झाड़ी के सामने क्या उतारना था?",
        options: ["अपने गहने", "अपनी जूतियाँ", "अपना चोगा", "अपनी पगड़ी"],
        hint: "जो पैरों में पहना जाता है",
        funFact: "👡 जूते उतारना पवित्र भूमि पर सम्मान व्यक्त करता है!"
      },
      medium: {
        question: "परमेश्वर ने मूसा को कौन सा नाम प्रकट किया?",
        options: [
          "यहोवा",
          "मैं जो हूँ सो हूँ",
          "सर्वशक्तिमान",
          "सृष्टिकर्ता"
        ],
        hint: "एक नाम जो परम अस्तित्व को व्यक्त करता है",
        funFact: "🔥 यहोवा (मैं हूँ) परमेश्वर के शाश्वत सार को प्रकट करता है!"
      },
      hard: {
        question: "जलती हुई झाड़ी जो भस्म नहीं होती, हमें क्या सिखाती है?",
        options: [
          "जादू मौजूद है",
          "परमेश्वर प्राकृतिक नियमों से परे है",
          "आग पवित्र है",
          "पौधे जादुई हैं"
        ],
        hint: "यह दैवीय प्रकृति के बारे में है जो हमारी समझ से परे है",
        funFact: "🌿 झाड़ी प्रतीक है कि दैवीय उपस्थिति नष्ट किए बिना पवित्र करती है!"
      }
    },

    16: {
      name: "मिस्र पर दस विपत्तियाँ",
      challenge: "फिरौन ने अपना मन कठोर किया और उनकी न सुनी...",
      easy: {
        question: "मिस्र की पहली विपत्ति क्या थी?",
        options: ["मेंढक", "पानी का खून बन जाना", "मक्खियाँ", "जूँ"],
        hint: "इसने नील नदी को प्रभावित किया, मिस्र के जीवन का स्रोत",
        funFact: "🩸 नील नदी की एक देवता के रूप में पूजा की जाती थी, और परमेश्वर ने अपनी श्रेष्ठता दिखाई!"
      },
      medium: {
        question: "अंतिम और सबसे भयानक विपत्ति कौन सी थी?",
        options: [
          "ओले",
          "अंधकार",
          "पहलौठों की मृत्यु",
          "टिड्डियाँ"
        ],
        hint: "इस विपत्ति ने परिवारों को सीधे प्रभावित किया",
        funFact: "😢 इस विपत्ति ने अंततः फिरौन के घमंड को तोड़ दिया और इस्राएल को मुक्त कर दिया!"
      },
      hard: {
        question: "परमेश्वर फिरौन के हृदय को कठोर क्यों करता है?",
        options: [
          "उसे दंडित करने के लिए",
          "अपनी महिमा और शक्ति प्रकट करने के लिए",
          "दुष्टता से",
          "पीड़ा को बढ़ाने के लिए"
        ],
        hint: "यह प्रकट करने के बारे में है कि सच्चा परमेश्वर कौन है",
        funFact: "⚡ विपत्तियाँ साबित करती हैं कि यहोवा सभी मिस्री देवताओं से अधिक शक्तिशाली है!"
      }
    },

    17: {
      name: "फसह",
      challenge: "अपने लिए एक मेमना लो... और उसका लोहू चौखट पर लगाओ...",
      easy: {
        question: "इस्राएलियों को मेमने का लहू कहाँ लगाना था?",
        options: [
          "अपने कपड़ों पर",
          "दरवाजों के चौखटों और बाजुओं पर",
          "अपने माथे पर",
          "प्यालों में"
        ],
        hint: "अपने घरों के प्रवेश द्वार पर",
        funFact: "🩸 दरवाजे पर लहू दैवीय सुरक्षा का चिन्ह था!"
      },
      medium: {
        question: "उन्हें फसह के मेमने को कैसे खाना था?",
        options: [
          "आराम से बैठकर",
          "केवल परिवार में",
          "कमर कसे हुए, पैरों में जूतियाँ, हाथ में लाठी",
          "मौन में"
        ],
        hint: "जाने के लिए तैयार",
        funFact: "🚶 उन्हें स्वतंत्रता की ओर तेजी से जाने के लिए तैयार रहना था!"
      },
      hard: {
        question: "फसह का मेमना मसीह का पूर्वाभास कैसे है?",
        options: [
          "इसकी सफेदी से",
          "इसके प्रतिस्थापन बलिदान द्वारा जो मृत्यु से बचाता है",
          "इसकी नम्रता से",
          "इसकी आयु से"
        ],
        hint: "यह उस बलिदान के बारे में है जो दण्ड से बचाता है",
        funFact: "🐑 यीशु को 'परमेश्वर का मेमना जो जगत का पाप उठा ले जाता है' कहा जाता है!"
      }
    },

    18: {
      name: "लाल सागर को पार करना",
      challenge: "और मूसा ने समुद्र के ऊपर अपना हाथ बढ़ाया...",
      easy: {
        question: "इस्राएलियों ने समुद्र को कैसे पार किया?",
        options: [
          "नाव में",
          "तैरकर",
          "सूखी भूमि पर",
          "बेड़े पर"
        ],
        hint: "समुद्र का तल चलने योग्य था",
        funFact: "🌊 परमेश्वर ने एक बाधा को मुक्ति का मार्ग बना दिया!"
      },
      medium: {
        question: "पीछा करने वाले मिस्रियों का क्या हुआ?",
        options: [
          "वे वापस मुड़ गए",
          "वे पानी में डूब गए",
          "वे खो गए",
          "वे इस्राएल से जुड़ गए"
        ],
        hint: "पानी उन पर वापस आ गया",
        funFact: "⚔️ दुनिया की सबसे शक्तिशाली सेना एक पल में नष्ट हो गई!"
      },
      hard: {
        question: "यह पार करना हमारे आध्यात्मिक जीवन में क्या प्रतीक है?",
        options: [
          "समस्याओं से पलायन",
          "पाप की दासता से परमेश्वर में स्वतंत्रता की ओर संक्रमण",
          "इस्राएल की श्रेष्ठता",
          "शत्रुओं का विनाश"
        ],
        hint: "यह आध्यात्मिक परिवर्तन के बारे में है",
        funFact: "🗽 लाल सागर बपतिस्मा का प्रतिनिधित्व करता है: पुराने के लिए मृत्यु, नया जीवन!"
      }
    },

    19: {
      name: "जंगल में मन्ना",
      challenge: "यह क्या है? क्योंकि वे नहीं जानते थे कि यह क्या है...",
      easy: {
        question: "मन्ना कितने समय तक गिरा?",
        options: ["10 वर्ष", "20 वर्ष", "40 वर्ष", "50 वर्ष"],
        hint: "जंगल में बिताए वर्षों की संख्या के समान",
        funFact: "🍞 40 वर्षों तक, परमेश्वर ने चमत्कारिक रूप से 2 मिलियन लोगों को भोजन दिया!"
      },
      medium: {
        question: "यदि वे एक दिन से अधिक मन्ना रखते तो क्या होता?",
        options: [
          "यह अधिक स्वादिष्ट हो जाता",
          "यह बढ़ जाता",
          "यह सड़ जाता और दुर्गंध आती",
          "यह कठोर हो जाता"
        ],
        hint: "सब्त के लिए शुक्रवार को छोड़कर",
        funFact: "🪱 परमेश्वर ने इस प्रकार उस पर दैनिक निर्भरता सिखाई!"
      },
      hard: {
        question: "मन्ना हमें विश्वास कैसे सिखाता है?",
        options: [
          "भविष्य के लिए भंडारण करके",
          "परमेश्वर के दैनिक प्रावधान पर भरोसा करके",
          "कठिन परिश्रम करके",
          "समान रूप से साझा करके"
        ],
        hint: "यह दिन-प्रतिदिन विश्वास करने के बारे में है",
        funFact: "🙏 'हमारी दैनिक रोटी आज हमें दे' इस अनुभव से आता है!"
      }
    },

    20: {
      name: "चट्टान से जल",
      challenge: "तू चट्टान पर मारना, और उससे जल निकलेगा...",
      easy: {
        question: "मूसा को चट्टान पर किससे मारना था?",
        options: ["अपने हाथ से", "अपनी लाठी से", "एक पत्थर से", "एक हथौड़े से"],
        hint: "मूसा के चमत्कारों का उपकरण",
        funFact: "⚡ मूसा की लाठी दैवीय शक्ति का साधन थी!"
      },
      medium: {
        question: "लोग मूसा के विरुद्ध क्यों बड़बड़ा रहे थे?",
        options: [
          "पीने के लिए पानी नहीं था",
          "भोजन की कमी थी",
          "रास्ता बहुत लंबा था",
          "बहुत गर्मी थी"
        ],
        hint: "रेगिस्तान में एक महत्वपूर्ण आवश्यकता",
        funFact: "💧 जीवित रहने के लिए जल भोजन से अधिक आवश्यक है!"
      },
      hard: {
        question: "चट्टान से जल आध्यात्मिक रूप से क्या दर्शाता है?",
        options: [
          "प्राकृतिक संसाधन",
          "आध्यात्मिक जीवन जो मसीह, चट्टान से निकलता है",
          "प्रयासों का इनाम",
          "दैवीय जादू"
        ],
        hint: "पौलुस कहता है कि यह चट्टान मसीह था",
        funFact: "🗿 मसीह वह चट्टान है जिस पर प्रहार किया गया जिससे अनन्त जीवन निकलता है!"
      }
    },

    21: {
      name: "सीनै पर्वत",
      challenge: "सारा सीनै पर्वत धुएँ से भर गया, क्योंकि यहोवा उस पर उतरा था...",
      easy: {
        question: "परमेश्वर ने कितनी आज्ञाएँ दीं?",
        options: ["5", "7", "10", "12"],
        hint: "एक पूर्ण संख्या",
        funFact: "📜 दस आज्ञाएँ मानवता की नैतिक नींव हैं!"
      },
      medium: {
        question: "आज्ञाएँ किस पर लिखी गई थीं?",
        options: [
          "पपाइरस पर",
          "चर्मपत्र पर",
          "पत्थर की दो पटियाओं पर",
          "कांस्य पर"
        ],
        hint: "एक टिकाऊ सामग्री जो परमेश्वर की उंगली से लिखी गई",
        funFact: "✍️ परमेश्वर द्वारा स्वयं लिखी गईं उनके शाश्वत महत्व को दिखाने के लिए!"
      },
      hard: {
        question: "दैवीय आज्ञाओं का उद्देश्य क्या है?",
        options: [
          "लोगों को दंडित करना",
          "परमेश्वर की पवित्रता प्रकट करना और सुख की ओर मार्गदर्शन करना",
          "जटिल नियम बनाना",
          "लोगों को अलग करना"
        ],
        hint: "यह दैवीय चरित्र और भलाई के मार्ग को प्रकट करने के बारे में है",
        funFact: "⚖️ आज्ञाएँ प्रेम को प्रकट करती हैं: परमेश्वर का प्रेम और पड़ोसी का प्रेम!"
      }
    },

    22: {
      name: "सोने का बछड़ा",
      challenge: "हमारे लिए देवता बना जो हमारे आगे-आगे चलें...",
      easy: {
        question: "हारून ने सोने के बछड़े को किससे बनाया?",
        options: [
          "सोने के सिक्के",
          "लोगों की सोने की बालियाँ",
          "बहुमूल्य गहने",
          "रेगिस्तान का सोना"
        ],
        hint: "लोगों द्वारा दिए गए व्यक्तिगत गहने",
        funFact: "👂 लोगों ने अपनी मूर्ति बनाने के लिए अपने गहने दिए!"
      },
      medium: {
        question: "बछड़े को देखकर मूसा की क्या प्रतिक्रिया थी?",
        options: [
          "वह रोया",
          "उसने प्रार्थना की",
          "उसने व्यवस्था की पटियाँ तोड़ दीं",
          "वह केवल क्रोधित हुआ"
        ],
        hint: "टूटी हुई वाचा का प्रतीकात्मक संकेत",
        funFact: "💥 पटियाँ तोड़ना दर्शाता था कि वाचा टूट गई थी!"
      },
      hard: {
        question: "मूर्तिपूजा आध्यात्मिक रूप से इतनी खतरनाक क्यों है?",
        options: [
          "यह महंगा है",
          "यह हृदय को सच्चे परमेश्वर से सृष्टि की ओर मोड़ देता है",
          "यह परिवारों को विभाजित करता है",
          "यह वर्जित है"
        ],
        hint: "यह सृष्टि को वह देने के बारे में है जो सृष्टिकर्ता का है",
        funFact: "💔 मूर्तिपूजा जीवित परमेश्वर के साथ विशेष संबंध को तोड़ देती है!"
      }
    },

    23: {
      name: "मिलाप वाला तम्बू",
      challenge: "वे मेरे लिए एक पवित्रस्थान बनाएँ, और मैं उनके बीच वास करूँगा...",
      easy: {
        question: "इस्राएलियों के पवित्र तम्बू को क्या कहा जाता था?",
        options: ["मंदिर", "मिलाप वाला तम्बू", "पवित्रस्थान", "सन्दूक"],
        hint: "नाम का अर्थ है 'मुलाकात का तम्बू'",
        funFact: "⛺ मिलाप वाला तम्बू परमेश्वर का अपने लोगों के साथ 'चलता-फिरता घर' था!"
      },
      medium: {
        question: "वाचा के सन्दूक में क्या था?",
        options: [
          "महायाजक के गहने",
          "व्यवस्था की पटियाँ, मन्ना, हारून की लाठी",
          "सोने के टुकड़े",
          "तोरा की पुस्तकें"
        ],
        hint: "परमेश्वर के साथ वाचा का प्रतीक तीन वस्तुएँ",
        funFact: "📦 सन्दूक में दैवीय विश्वासयोग्यता की 'यादगार' थीं!"
      },
      hard: {
        question: "तम्बू परमेश्वर के साथ हमारे संबंध में क्या प्रतीक है?",
        options: [
          "एक धार्मिक भवन",
          "परमेश्वर की उपस्थिति जो हमारे बीच और हम में वास करती है",
          "केवल बलिदान का स्थान",
          "एक राष्ट्रीय प्रतीक"
        ],
        hint: "यह सुलभ दैवीय उपस्थिति के बारे में है",
        funFact: "🏠 पौलुस के अनुसार 'तुम्हारा शरीर पवित्र आत्मा का मंदिर है'!"
      }
    },

    24: {
      name: "महायाजक हारून",
      challenge: "तू हारून और उसके पुत्रों को पवित्र करना ताकि वे मेरे याजक बनें...",
      easy: {
        question: "इस्राएल का पहला महायाजक कौन था?",
        options: ["मूसा", "हारून", "यहोशू", "एलीआजर"],
        hint: "मूसा का भाई",
        funFact: "👨‍⚕️ हारून ने याजकीय वंश की स्थापना की जो 1000 साल से अधिक चला!"
      },
      medium: {
        question: "महायाजक अपने सीने पर क्या पहनता था?",
        options: [
          "एक सोने का क्रूस",
          "बारह बहुमूल्य पत्थरों वाला सीनाबन्द",
          "एक पदक",
          "एक सोने की जंजीर"
        ],
        hint: "बारह पत्थर जो बारह गोत्रों का प्रतिनिधित्व करते हैं",
        funFact: "💎 महायाजक प्रतीकात्मक रूप से सारे इस्राएल को अपने हृदय पर धारण करता था!"
      },
      hard: {
        question: "यीशु महायाजक की भूमिका कैसे पूरी करता है?",
        options: [
          "पवित्र वस्त्र पहनकर",
          "अपना स्वयं का लहू सदा के लिए चढ़ाकर",
          "मंदिर में सेवा करके",
          "हारून का वंशज होकर"
        ],
        hint: "यह एक पूर्ण और अंतिम बलिदान के बारे में है",
        funFact: "✝️ यीशु मलिकिसिदक की रीति पर सदा का महायाजक है!"
      }
    },

    25: {
      name: "बलिदान",
      challenge: "यदि तुम में से कोई यहोवा को भेंट चढ़ाए...",
      easy: {
        question: "तम्बू में दैनिक बलिदान क्या था?",
        options: [
          "मेलबलि",
          "सुबह और शाम का होमबलि",
          "पापबलि",
          "अन्नबलि"
        ],
        hint: "दिन में दो बार, सुबह और शाम",
        funFact: "🔥 वेदी पर की आग कभी बुझनी नहीं थी!"
      },
      medium: {
        question: "पशु पर हाथ रखना क्या दर्शाता था?",
        options: [
          "आशीर्वाद",
          "पापों का बलि पर स्थानांतरण",
          "पशु के लिए स्नेह",
          "समर्पण"
        ],
        hint: "प्रतिस्थापन का संकेत",
        funFact: "🤲 पशु पापी के स्थान पर मरता था - प्रतिस्थापन का सिद्धांत!"
      },
      hard: {
        question: "ये बलिदान मसीह के कार्य का पूर्वाभास कैसे हैं?",
        options: [
          "उनकी संख्या द्वारा",
          "प्रतिस्थापन द्वारा: निर्दोष दोषी के लिए मरता है",
          "उनकी कीमत द्वारा",
          "उनकी सुंदरता द्वारा"
        ],
        hint: "यह निर्दोष के दोषी का स्थान लेने के सिद्धांत के बारे में है",
        funFact: "🐑 'वह हमारे अपराधों के लिए घायल किया गया, हमारे अधर्म के लिए कुचला गया'!"
      }
    },

    26: {
      name: "प्रतिज्ञा की भूमि की सीमा पर",
      challenge: "मैं तुम्हारे आगे एक दूत भेजूँगा, और कनानियों को निकाल दूँगा...",
      easy: {
        question: "प्रतिज्ञा की भूमि का पता लगाने के लिए कितने भेदिए भेजे गए थे?",
        options: ["10", "12", "20", "40"],
        hint: "इस्राएल के प्रत्येक गोत्र से एक",
        funFact: "🕵️ केवल 12 में से 2 भेदियों ने उत्साहजनक रिपोर्ट दी!"
      },
      medium: {
        question: "किन भेदियों ने लोगों को भूमि में प्रवेश करने के लिए प्रोत्साहित किया?",
        options: [
          "हारून और मूसा",
          "यहोशू और कालेब",
          "गाद और आशेर",
          "रूबेन और शिमोन"
        ],
        hint: "विश्वास के दो पुरुष जिन्होंने परमेश्वर की प्रतिज्ञाओं को देखा",
        funFact: "🦁 यहोशू और कालेब अपनी पीढ़ी के एकमात्र लोग थे जो कनान में प्रवेश किए!"
      },
      hard: {
        question: "इस्राएल 40 वर्ष तक जंगल में क्यों भटकता रहा?",
        options: [
          "उन्हें दंडित करने के लिए",
          "दैवीय प्रतिज्ञाओं पर उनके अविश्वास के कारण",
          "उन्हें युद्ध के लिए प्रशिक्षित करने के लिए",
          "सही रास्ता खोजने के लिए"
        ],
        hint: "यह परमेश्वर में विश्वास की कमी के बारे में है",
        funFact: "🏜️ अविश्वास के कारण एक पूरी पीढ़ी को मरना पड़ा!"
      }
    }
  }
};

export default chapter2Translations;
